module.exports = __webpack_public_path__ + "img/func_5_2.a58b7cd1.svg";